export default {
  modalId: 'FWContentEditorModal',
  actionAttr: 'data-fwcontent-editor-tag',
  templates: {
    /** Tags list */
    tags: {
      text: {name: 'Text', value: ['h1', 'h2', 'h3', 'p'], collapsible: false},
      forms: {name: 'Inputs', value: ['button'], collapsible: false},
      rte: {name: 'Rich text editors', value: ['summernote'], collapsible: false}
    },
    /** Example cards HTML block */
    cards: {
      contact: {
        name: 'Forms', value: [
          {
            name: 'Contact us',
            value: '<div class="container">\n' +
              '    <div class="row">\n' +
              '        <div class="col-lg-12"><h3>Contact Us</h3></div>\n' +
              '    </div>\n' +
              '    <div class="row">\n' +
              '        <div class="col-lg-12">\n' +
              '            <form name="contactForm" novalidate="novalidate">\n' +
              '                <div class="form-row">\n' +
              '                    <div class="col col-lg-12 text-center">\n' +
              '                        <div class="form-group"><input class="form-control" type="text" id="name"\n' +
              '                                                       placeholder="Your Name" required="">\n' +
              '                        </div>\n' +
              '                        <div class="form-group"><input class="form-control" type="email" id="email"\n' +
              '                                                       placeholder="Your Email" required="">\n' +
              '                        </div>\n' +
              '                        <div class="form-group"><input class="form-control" type="tel" placeholder="Your Phone"\n' +
              '                                                       required="">\n' +
              '                        </div>\n' +
              '                        <div class="form-group"><textarea class="form-control" id="message" placeholder="Your Message"\n' +
              '                                                          required=""></textarea>\n' +
              '                        </div>\n' +
              '                    </div>\n' +
              '                    <div class="col-lg-12 text-center">\n' +
              '                        <button class="btn btn-primary btn-xl text-uppercase" id="sendMessageButton" type="submit">Send\n' +
              '                            Message\n' +
              '                        </button>\n' +
              '                    </div>\n' +
              '                </div>\n' +
              '            </form>\n' +
              '        </div>\n' +
              '    </div>\n' +
              '</div>'
          },
          {
            name: 'Newsletter subscribe',
            value: '<div class="container">\n' +
              '    <div class="intro"><h3 class="text-center">Subscribe for our Newsletter</h3></div>\n' +
              '    <form class="form-inline" method="post">\n' +
              '        <div class="form-group"><input class="form-control" type="email" name="email" placeholder="Your Email">\n' +
              '        </div>\n' +
              '        <div class="form-group">\n' +
              '            <button class="btn btn-primary" type="submit">Subscribe</button>\n' +
              '        </div>\n' +
              '    </form>\n' +
              '</div>\n'
          },
        ], collapsible: true
      },
      dashboard: {
        name: 'Dashboard', value: [
          {
            name: 'Earnings (annual)',
            value: '<div class="card shadow border-left-success py-2">\n' +
              '    <div class="card-body">\n' +
              '        <div class="row align-items-center no-gutters">\n' +
              '            <div class="col mr-2">\n' +
              '                <div class="text-uppercase text-success font-weight-bold text-xs mb-1"><span>Earnings (annual)</span>\n' +
              '                </div>\n' +
              '                <div class="text-dark font-weight-bold h5 mb-0"><span>$215,000</span></div>\n' +
              '            </div>\n' +
              '            <div class="col-auto"><i class="fas fa-dollar-sign fa-2x text-gray-300"></i></div>\n' +
              '        </div>\n' +
              '    </div>\n' +
              '</div>'
          },
          {
            name: 'Earnings (monthly)',
            value: '<div class="card shadow border-left-primary py-2">\n' +
              '    <div class="card-body">\n' +
              '        <div class="row align-items-center no-gutters">\n' +
              '            <div class="col mr-2">\n' +
              '                <div class="text-uppercase text-primary font-weight-bold text-xs mb-1"><span>Earnings (monthly)</span>\n' +
              '                </div>\n' +
              '                <div class="text-dark font-weight-bold h5 mb-0"><span>$40,000</span></div>\n' +
              '            </div>\n' +
              '            <div class="col-auto"><i class="fas fa-calendar fa-2x text-gray-300"></i></div>\n' +
              '        </div>\n' +
              '    </div>\n' +
              '</div>'
          },
          {
            name: 'Todo list',
            value: '<div class="card shadow mb-4">\n' +
              '    <div class="card-header"><h6 class="text-primary font-weight-bold m-0">Todo List</h6></div>\n' +
              '    <ul class="list-group list-group-flush">\n' +
              '        <li class="list-group-item">\n' +
              '            <div class="row align-items-center no-gutters">\n' +
              '                <div class="col-lg-12"><h6 class="mb-0"><strong>Lunch meeting</strong></h6><span\n' +
              '                        class="text-xs">10:30 AM</span></div>\n' +
              '            </div>\n' +
              '        </li>\n' +
              '        <li class="list-group-item">\n' +
              '            <div class="row align-items-center no-gutters">\n' +
              '                <div class="col-lg-12"><h6 class="mb-0"><strong>Lunch meeting</strong></h6><span\n' +
              '                        class="text-xs">10:30 AM</span></div>\n' +
              '            </div>\n' +
              '        </li>\n' +
              '        <li class="list-group-item">\n' +
              '            <div class="row align-items-center no-gutters">\n' +
              '                <div class="col-lg-12"><h6 class="mb-0"><strong>Lunch meeting</strong></h6><span\n' +
              '                        class="text-xs">10:30 AM</span></div>\n' +
              '            </div>\n' +
              '        </li>\n' +
              '    </ul>\n' +
              '</div>'
          }
        ], collapsible: true
      },
      statistic: {
        name: 'Statistic', value: [
          {
            name: 'Projects',
            value: '<div class="card shadow mb-4">\n' +
              '    <div class="card-header py-3"><h6 class="text-primary font-weight-bold m-0">Projects</h6></div>\n' +
              '    <div class="card-body"><h4 class="small font-weight-bold">Server migration<span class="float-right">20%</span></h4>\n' +
              '        <div class="progress mb-4">\n' +
              '            <div class="progress-bar bg-danger" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"\n' +
              '                 style="width: 20%;"><span class="sr-only">20%</span></div>\n' +
              '        </div>\n' +
              '        <h4 class="small font-weight-bold">Sales tracking<span class="float-right">40%</span></h4>\n' +
              '        <div class="progress mb-4">\n' +
              '            <div class="progress-bar bg-warning" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"\n' +
              '                 style="width: 40%;"><span class="sr-only">40%</span></div>\n' +
              '        </div>\n' +
              '        <h4 class="small font-weight-bold">Customer Database<span class="float-right">60%</span></h4>\n' +
              '        <div class="progress mb-4">\n' +
              '            <div class="progress-bar bg-primary" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"\n' +
              '                 style="width: 60%;"><span class="sr-only">60%</span></div>\n' +
              '        </div>\n' +
              '        <h4 class="small font-weight-bold">Payout Details<span class="float-right">80%</span></h4>\n' +
              '        <div class="progress mb-4">\n' +
              '            <div class="progress-bar bg-info" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"\n' +
              '                 style="width: 80%;"><span class="sr-only">80%</span></div>\n' +
              '        </div>\n' +
              '        <h4 class="small font-weight-bold">Account setup<span class="float-right">Complete!</span></h4>\n' +
              '        <div class="progress mb-4">\n' +
              '            <div class="progress-bar bg-success" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"\n' +
              '                 style="width: 100%;"><span class="sr-only">100%</span></div>\n' +
              '        </div>\n' +
              '    </div>\n' +
              '</div>'
          },
        ], collapsible: true
      }
    },
  },
  actions: {
    render (col, initialContent, actionAttr, modalId, templates, updateTemplate) {
      let modal = $('#' + modalId),
        classes = []
      if (modal.length) {
        modal.remove()
      }

      /** render Elements from templates */
      modal = $('<div id="' + modalId + '" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="z-index: 999999;">' +
        '<div class="modal-dialog" role="document">' +
        '<div class="modal-content" />' +
        '' +
        '</div>')

      /**
       * templates.tags[tagCatKey] =
       * { name: 'Text', value: ['h1','h2','h3','p'], collapsible: false };
       * tagCatKey = "text"
       * */
      for (let tagCatKey in templates.tags) {
        if (templates.tags.hasOwnProperty(tagCatKey)) {
          modal.find('.modal-content').append(
            '<div class="card mb-0">' +
            getCatHeading('Tag', tagCatKey, templates.tags[tagCatKey]) +
            '<div id="TemplateTagBody_' + tagCatKey + '" ' +
            'class="collapse ' + (templates.tags[tagCatKey].collapsible ? ' show ' : ' show ') + '" ' +
            'aria-labelledby="TemplateTagHead_' + tagCatKey + '" class=""><div class="card-body d-flex">' +
            $.map(templates.tags[tagCatKey].value, function (tag) {
              if (isValidTag(tag)) {
                classes = []
                if (tag === 'button') {
                  classes.push('btn')
                }
                return '<div class="item flex-fill" ' + actionAttr + '="' + tag + '"><' + tag + ' ' + (classes.length ? 'class="' + classes.join(' ') + '"' : '') + ' >' + tag.toUpperCase() + '</' + tag + '></div>\n'
              } else {
                return '<div class="item flex-fill" ' + actionAttr + '="' + tag + '">' + tag.toUpperCase() + '</div>\n'
              }
            }).join('') +
            '</div></div>' +
            '</div>')
        }
      }

      for (let cardCatKey in templates.cards) {
        if (templates.cards.hasOwnProperty(cardCatKey)) {
          modal.find('.modal-content').append(
            '<div class="card mb-0">' +
            getCatHeading('Card', cardCatKey, templates.cards[cardCatKey]) +
            '<div id="TemplateCardBody_' + cardCatKey + '" ' +
            'class="collapse ' + (templates.cards[cardCatKey].collapsible ? ' show ' : ' show ') + ' list-group" ' +
            'aria-labelledby="TemplateCardHead_' + cardCatKey + '"><div class="card-body">' +
            $.map(templates.cards[cardCatKey].value, function (card) {
              return '<div class="list-group-item list-group-item-action" ' + actionAttr + '="card">' + card.value + '</div>\n'
            }).join('') +
            '</div></div>' +
            '</div>')
        }
      }

      modal.appendTo('body').modal('toggle')

      /** init Callbacks */
      $('[' + actionAttr + ']').on({
        click: function () {
          try {
            let tag = $(this).attr(actionAttr)
            if (isValidTag(tag)) {
              classes = []
              if (tag === 'button') {
                classes.push('btn')
              }
              $('<' + tag + ' ' + (classes.length ? 'class="' + classes.join(' ') + '"' : '') + '>text here</' + tag + '>').appendTo(col)
            } else if (tag === 'summernote') {
              col.append('<div data-ge-content-type="summernote" class="' + 'ge-content ge-content-type-summernote">' + initialContent + '</div>')
              if (typeof updateTemplate === 'function') {
                updateTemplate()
              }
            } else if (tag === 'card') {
              col.append($(this).html())
            } else {
              /** take from encoded attribute value */
              col.append(htmlDecode(tag))
            }
            if (typeof updateTemplate === 'function') {
              updateTemplate()
            }
          } catch (e) {
            console.error(e)
          }
          $('#' + modalId).modal('toggle')
        }
      })
    }
  }
}

/** HELPERS SIMPLE FUNCTIONS**/

/**
 * checks if string is valid tagName
 * @param tag
 * @returns {boolean}
 */
function isValidTag (tag) {
  return document.createElement(tag).toString() != '[object HTMLUnknownElement]'
}

//TODO fix this
function htmlEncode (value) {
  return $('<textarea/>').text(value).html()
}

function htmlDecode (value) {
  return $('<textarea/>').html(value).text()
}

function getCatHeading (enitity, key, cat) {
  return '<div class="card-header" id="Template' + enitity + 'Head_' + key + '">\n' +
    '<h2 class="mb-0">\n' +
    '<button ' + (cat.collapsible ? '' : ' disabled=disabled ') +
    'class="btn btn-link" type="button" data-toggle="collapse" data-target="#Template' + enitity + 'Body_' + key + '" ' +
    'aria-expanded="true" aria-controls="Template' + enitity + 'Body_' + key + '">\n' +
    cat.name +
    '</button>\n' +
    '</h2>\n' +
    '</div>'
}
